export default "__VITE_ASSET__c932dca3__"